<button #open (click)="openDialog()">
  {{ 'anonymousConsents.preferences' | cxTranslate }}
</button>
